import { useLocation } from "react-router-dom";

import { DirectBuyStatus } from "@/components/signup/post-order/src/components";

export type SearchParameters = {
    readonly orderId: string;
    readonly transactionAccount: string;
    readonly directBuyStatus?: DirectBuyStatus;
};

/**
 * @returns {URLSearchParams} The search (query) parameters from the URL.
 *
 * This function is used to get the search parameters from the URL.
 * If in a router context, it uses the {@link useLocation} hook,
 * otherwise it uses the global location.
 */
const getSearchParameters = (): URLSearchParams => {
    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return new URLSearchParams(useLocation().search);
    } catch {
        return new URLSearchParams(window.location.search);
    }
};

export function useSearchParameters(): SearchParameters {
    const searchParameters = getSearchParameters();
    const orderId = searchParameters.get("orderId") ?? "";
    const transactionAccount = searchParameters.get("transactionAccount") ?? "";
    const directBuyStatus =
        (searchParameters.get("directBuyStatus") as DirectBuyStatus) ?? "";

    return {
        orderId,
        transactionAccount,
        directBuyStatus
    };
}
